import React, { Fragment, useEffect, useLayoutEffect, useRef, useState } from "react";
// import ClientDetails from "lib/ClientDetails";
import DashBoard from "components/DashBoard";
// import { detailViewConfig as dashboardDetailConfiguration } from "assets/detailViewConfig";
import NoDataFoundPic from "assets/images/NoDataFoundPic.png";
import Sign_desk_logo from "assets/images/signdesk_logo.svg";
import DynamicForm from "components/DynamicForm";
import { setSelectedData } from "redux/formDisplay";

import ActivitySection from "lib/ActivityList";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchSubWorkflowInfoById,
  fetchWorkflowInfoById,
  ncifResponse,
  // fetchAgreementsOfSubWorkflow,
  fetchDashboardDetailConfiguration,
  welcomeLetter,
  getEmandateStatus,
} from "api/dashboardDetail";
import {
  resetSuccessFullySentTouser,
  setCurrentSubworkFlowId,
  setDashBoardDetailData,
  setLogoutUrl,
  setActiveNavTab,
  setActionSuccess,
  setCheckingForApprovalButtonConstraint,
  setShouldShowActionButtonsForApproval
} from "redux/dashBoardDetailReducer";
import LoadingSpinner from "lib/LoadingSpinner";
import Toast from "components/ToastComponent";
import { getConfiguration } from "api/configuration";
import moment from "moment";
import { getURLParams } from "api/UrlEncryption";
import { getAllRolesByOrg, getAllUsersByOrg } from "api/dashboard";
import { clearPopupData } from "redux/popupReducer";
import { ClearDocuments, ClearUploadedDocument } from "redux/uploadDocumentReducer";
import { getRolesInfo } from "api/user";
import Autologout from "helper/Autologout";
import { Row,Offcanvas,Button, Col, Image, Container } from "react-bootstrap";
import { getCountriesCode } from "api/formDisplay";
import { setLoadingState } from "redux/staticData";
import signdeskLogo from "assets/images/signdesk_logo.svg";
import { clearConfiguration } from "redux/configurationReducer";
import { Navbar,Dropdown,Nav } from "react-bootstrap";
import { getProfilePicName } from "helper/common";
import { fetchApproversUserIds, fetchEstampPaymentData } from "api/payment";
import { setAppColor } from "helper";
import ResponsiveDropdown from "lib/ResponsiveDropdown";
import { storeLogoutToken } from "../../api/userAuth";



const DetailViewDashboard = (props) => {
  const dispatch = useDispatch();
  const stateErrRef = useRef();
  const [formErr, setFormErr] = useState({});
  stateErrRef.current = { ...formErr };
  const params = useParams();
  const IndirectEval = (evalString) => {
    return eval(evalString);
  };
  const [activeTab, setActiveTab] = useState("");
  const [sessiontimeout, setSessionTimeout] = useState(false)
  const [defaultDuration, setDefaultDuration] = useState('')
  const [dashBoardConfigData, setDashBoardConfigData] = useState({});
  const [poweredBy, setPoweredBy] = useState(false);
  const urlParams = useSelector((state) => state?.urlEncryption?.urlParams);
  const [toggleIcon,setToggleIcon]=useState(false)

  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const organisation_id = useSelector(
    (state) => state?.loggedInUserInfo?.userAuthInfo
  ).organisationInfo?._id;

  const paymentLoader = useSelector(
    (state) => state?.paymentReducer?.fetchingPaymentDetails
  );

  const currentUserRole =
    loggedInUserInfo?.modules?.find(
      (module) => module?.module_name === "low_code_detail_view"
    ) || {};
  // const { allUsers } = useSelector((state) => state.dash);
  const { allRoles, allUsers } = useSelector((state) => state.dashboardReducer);


  // low code approach to get all roles from api based organisation roles
  let currentUser = loggedInUserInfo?.profileInfo?.role_name;
  if(!currentUser && allRoles?.length){
    currentUser =
    loggedInUserInfo?.profileInfo?.role_name ||
    allRoles?.find((role) => role._id === loggedInUserInfo?.profileInfo?.role)
    ?.name
  }
  
  useEffect(() => {
    dispatch(getURLParams(params));
    
    setAppColor(loggedInUserInfo?.organisationInfo?.layout_setting)
    if (!allUsers?.length) {
      dispatch(
        getAllUsersByOrg({ id: loggedInUserInfo?.organisationInfo?._id })
      );
    }
    let userToken = JSON.parse(localStorage.getItem("userToken"));
    let queryParams = {
      role_id: userToken?.role?userToken?.role:loggedInUserInfo?.profileInfo?.role,
      organisation_id: userToken?.userOrg? userToken?.userOrg:loggedInUserInfo?.organisationInfo?._id
    }
    dispatch(getRolesInfo(queryParams))
    setPoweredBy(loggedInUserInfo?.organisationInfo?.white_labeled ? loggedInUserInfo?.organisationInfo?.white_labeled : false);
    if (!allRoles?.length) {
      dispatch(
        getAllRolesByOrg({ id: loggedInUserInfo?.organisationInfo?._id })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps

    return ()=>{
      dispatch(clearConfiguration())
     }
  }, [])
  const {
    currentSubWorkFlowId,
    usersList,
    workFlowInfo,
    workFlowInfoLoading,
    userSubworkFlowInfo,
    dashboardDetailData,
    dashboardDetailConfiguration,
    welcomeLetterHtmlContent,
    // sideBarStructure,
    toastContainer,
  } = useSelector((state) => state.dashboardDetailReducer);

  const estamp_payments = useSelector(state => state.paymentReducer.estamp_payments);

  // const detailViewSidebar = useSelector((state) => state.dashboardReducer?.dashboardDetailConfiguration)

  const successFullyRequestedDocs = useSelector(
    (state) => state?.dashboardDetailReducer?.successFullySentTouser
  );
  const dynamicConfigID = useSelector(
    (state) => state?.dashboardReducer?.dynamicConfigId)
  const successFullySentRequestForSupportingDocumentsTouser = useSelector(
    (state) =>
      state?.dashboardDetailReducer
        ?.successFullySentRequestForSupportingDocumentsTouser
  );
  const editUserDataRoutedSuccessFully = useSelector(
    (state) => state?.dashboardDetailReducer?.editUserDataRoutedSuccessFully
  );
  const wfJourney = useSelector(
    (state) => state?.configurationReducer?.config?.wf_journey
  );

  const noDataFoundForTheGivenId = useSelector(
    (state) => state?.dashboardDetailReducer?.noDataFoundForTheGivenId
  );
  const staticData = useSelector((state) => state?.staticData);
  const status = useSelector((state) => state.staticData?.status);
  const clientLogoutURL = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)?.setting?.logout_url;
  const checkingForApprovalButtonConstraint = useSelector((state) => state?.dashboardDetailReducer?.checkingForApprovalButtonConstraint);
  const [isGroupApproval, setIsGroupApproval] = useState(false)
  const checkingForApprovalButtonConstraintInProgress = useRef(false);

  useLayoutEffect(() => {
    if (urlParams.primaryWorkflowId) {
      dispatch(resetSuccessFullySentTouser());
      if(urlParams.primaryWorkflowId === userSubworkFlowInfo?.primary_workflow_id) return;
      dispatch(fetchWorkflowInfoById(urlParams.primaryWorkflowId));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlParams]);

  useEffect(() => {
    if (workFlowInfo) {
      const subWfId = workFlowInfo?.source_data?.subworkflows?.[0]?._id;
      if(urlParams.primaryWorkflowId === userSubworkFlowInfo?.primary_workflow_id) return;
      dispatch(setCurrentSubworkFlowId(currentSubWorkFlowId || subWfId));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [workFlowInfo]);

 useEffect(() => {
  if(loggedInUserInfo?.organisationInfo){
    const sessionDuration = loggedInUserInfo?.organisationInfo?.setting?.logout_duration

    let logoutDuration = sessionDuration || 20
    logoutDuration = logoutDuration * 60 * 1000
    setDefaultDuration(logoutDuration)

  }
}, [loggedInUserInfo])

const sessionTrigger = () => {
  if(defaultDuration){
    setSessionTimeout(true)
  }
}

setTimeout(() => {
  sessionTrigger()
}, defaultDuration)

  useEffect(() => {
    if (currentSubWorkFlowId) {
      dispatch(fetchEstampPaymentData(currentSubWorkFlowId))
      dispatch(fetchSubWorkflowInfoById(currentSubWorkFlowId))
        .unwrap()
        .then((result) => {
          if (!(wfJourney?.length > 0)) {
            dispatch(getConfiguration(result?.configuration_id));
          }
        });
        dispatch(clearPopupData())
        dispatch(ClearUploadedDocument())
        dispatch(ClearDocuments())
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSubWorkFlowId]);

  useEffect(() => {
    if (workFlowInfo?.source_data || userSubworkFlowInfo?.source_data) {
      let estamp_callbacks = estamp_payments?.length ? estamp_payments : [];
      let subworkFlowInfo = {
        ...userSubworkFlowInfo?.source_data,
        ...userSubworkFlowInfo,
        active_step: userSubworkFlowInfo?.active_step,
        status: userSubworkFlowInfo?.status,
      };
      delete subworkFlowInfo?.source_data;

      let data = {
        primaryworkflow: {
          ...workFlowInfo?.source_data?.subworkflows[0],
          ...workFlowInfo?.source_data,
          ...workFlowInfo,
        },
        subworkFlowInfo: {
          ...workFlowInfo?.source_data,
          ...usersList?.[currentSubWorkFlowId],
          ...subworkFlowInfo,
          welcomeLetterHtmlContent: welcomeLetterHtmlContent,
        },
        subworkflows: [...(workFlowInfo?.source_data?.subworkflows ?? [])],
        current_user: currentUser,
        payment_flows: workFlowInfo?.payment_ids,
        estamp_payments: estamp_callbacks,
        approvalQuiz: userSubworkFlowInfo?.approvalQuiz,
      };
      const module = wfJourney?.find(
        (wf) => wf?.step === data?.subworkFlowInfo?.active_step
      ); 
      dispatch(setDashBoardDetailData(data));
      dispatch(setActionSuccess(true))
      if(wfJourney){
        if(!module) return 
        if(!module?.module_settings ){
          return;
        }
        const { module_settings } = module;
        if (!module_settings?.approved_by) {
          return;
        }
        const { approved_by } = module_settings;
        if (approved_by?.type && approved_by?.group_id?.length) {
          checkingForApprovalButtonConstraintInProgress.current = true;
          dispatch(setCheckingForApprovalButtonConstraint(true));
          approvalButtonConstraintCheckForGroupApproval(module, data);
        }
        if (

          wfJourney &&
          eval(module?.module_settings?.ncif_evaluation_required) &&
          data?.subworkFlowInfo?.full_name
        ) {
          let wfUserName = data?.subworkFlowInfo?.signers_info?.filter(
            (item) => {
              return item?.signer_email == data?.subworkFlowInfo?.email
            }
          )
          dispatch(
            ncifResponse({
              full_name: wfUserName[0]?.signer_name,
              // full_name:'osama bin laden',
              date_of_birth: moment(
                data?.subworkFlowInfo?.birth_date?.split("/")?.reverse().join("/")
              ).format("YYYY-MM-DD"),
              organisation_id: data?.subworkFlowInfo?.organisation_id,
              wf_id: data?.subworkFlowInfo?._id
            })
          );
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [userSubworkFlowInfo, workFlowInfo, welcomeLetterHtmlContent, wfJourney, estamp_payments]);

 const approvalButtonConstraintCheckForGroupApproval = async (module, dataSelected) => {
  try {
    const { module_settings } = module;

    if (!module_settings || !module_settings.approved_by) {
      dispatch(setShouldShowActionButtonsForApproval(false));
      return false;
    }

    const { approved_by } = module_settings;

    if (approved_by.type && approved_by.group_id?.length) {
      const {
        type,
        group_id,
        min_approvers
      } = approved_by;

      const payload = {
        approval_type: type,
        approvalMetaDataArray: group_id,
        organisation_id,
        checkShouldShowApprovalButtonForUserGroup: true,
        loggedInUserId: loggedInUserInfo?.profileInfo?.userId,
        workflowId: dataSelected?.subworkFlowInfo?._id,
        role: loggedInUserInfo?.profileInfo?.role,
        step: dataSelected?.subworkFlowInfo?.active_step,
        min_approvers,
      };

      dispatch(setCheckingForApprovalButtonConstraint(true));

      const result = await dispatch(fetchApproversUserIds(payload));

      setIsGroupApproval(result.payload?.data?.success);

      dispatch(setShouldShowActionButtonsForApproval(result.payload?.data?.success));
    }

    return;
  } catch (error) {
    console.error("Error in approvalButtonConstraintCheckForGroupApproval:", error);
    return false;
  } finally {
    checkingForApprovalButtonConstraintInProgress.current = false;
    dispatch(setCheckingForApprovalButtonConstraint(false));
  }
};


  useEffect(() => {
    if (organisation_id && currentSubWorkFlowId) {
      
      if (organisation_id && currentSubWorkFlowId) {
        let statusParams = {
          sub_wf_id: currentSubWorkFlowId,
          organisation_id: organisation_id
        }
        dispatch(getEmandateStatus(statusParams));
        if (
          !dashboardDetailConfiguration ||
          !Object.keys(dashboardDetailConfiguration).length ||
          dashboardDetailConfiguration?.configurationInfo?.module_id !==
          urlParams?.module_id || dynamicConfigID !== undefined
        ) {
          const dashboardBody = {
            workFlowId:urlParams?.primaryWorkflowId,
            organisation_id: organisation_id,
            config_type: "dashboard_detail",
            module_id: urlParams?.module_id,
            role_id: loggedInUserInfo?.profileInfo?.role
          };
          dispatch(fetchDashboardDetailConfiguration(dashboardBody));
        }
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSubWorkFlowId, organisation_id,urlParams,dynamicConfigID]);
  useEffect(() => {
    if (
      dashboardDetailConfiguration &&
      Object.keys(dashboardDetailConfiguration).length
    ) {
      setDashBoardConfigData(dashboardDetailConfiguration?.configurationInfo);
      // will use logout url from organisation level and not from dashboard so commenting the below line
      // dispatch(setLogoutUrl(dashboardDetailConfiguration?.configurationInfo?.logout_url));
    }
    if (staticData?.countryData?.length == 0 && status == false) {
      dispatch(setLoadingState(true));
      dispatch(getCountriesCode());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardDetailConfiguration]);

  useEffect(() => {
    if (
      dashboardDetailData?.subworkFlowInfo?.active_step &&
      !welcomeLetterHtmlContent &&
      dashboardDetailConfiguration &&
      dashboardDetailConfiguration?.configurationInfo
    ) {
      const selectedData = dashboardDetailData; // using in eval
      const welcomeLetterTrigger =
        dashboardDetailConfiguration?.configurationInfo?.welcomeLetterTrigger;
      const trigger =
        (welcomeLetterTrigger && eval(welcomeLetterTrigger)) || "WelcomeLetter";
      if (
        userSubworkFlowInfo?.status &&
        (userSubworkFlowInfo.status?.toLowerCase() ===
          "awaiting welcome letter approval" ||
          userSubworkFlowInfo.status?.toLowerCase() ===
            "'awaiting welcome letter approval'")
      ) {
        dispatch(
          welcomeLetter({
            sub_id: currentSubWorkFlowId,
            organisation_id,
            trigger: trigger,
          })
        );
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [dashboardDetailConfiguration, userSubworkFlowInfo, dashboardDetailData]);

  // sections = {},
  let formSkeleton = {};
  let headerSkeleton=[]
  // tab = {} 

  if (dashBoardConfigData && Object.keys(dashBoardConfigData)?.length) {
    let formStructure = [];
    let headerData=[]
    dashBoardConfigData?.wf_journey?.map((item, index) => {
      formStructure = { ...item?.form_structure };
      headerData={...item?.header_structure}    
    });  
    formSkeleton = formStructure?.sections;
    headerSkeleton=headerData  
  }

  const handleCommonTabChange = (value) => {
    dispatch(setCurrentSubworkFlowId(value));
  };
 const value =  IndirectEval(formSkeleton?.[1]?.show) ? 9 : 12;
  if (
    workFlowInfoLoading ||
    !dashBoardConfigData?.wf_journey ||
    checkingForApprovalButtonConstraint ||
    checkingForApprovalButtonConstraintInProgress.current
  ) {
    return <LoadingSpinner />;
  }
  const logout = async () => {
    let userToken = JSON.parse(localStorage.getItem("userToken"));
    let response= await storeLogoutToken(userToken);
    localStorage.clear();
    window.location.href = clientLogoutURL
        ? clientLogoutURL
        : "/accounts/login";

};
const handleActiveTab = (title)=>{
  setActiveTab(title)
  dispatch(setActiveNavTab(title));
}

const clearFieldError = (fields, isList) => {
  fields = isList ? fields : [fields];
  let err = { ...stateErrRef?.current };

  for (let key in fields) {
    const _field = fields[key];
    if (err[_field] !== undefined) {
      delete err[_field];
    }
  }
  setFormErr(err);
};

const selectedData = {
  ...dashboardDetailData,
  commonTabKey: currentSubWorkFlowId,
  setCommonTabKey: handleCommonTabChange,
  currentUserRole: currentUserRole,
  isGroupApproval: isGroupApproval,
};

  return (
      <DashBoard
          templateName={dashBoardConfigData?.template_name}
          noDataFoundForTheGivenId={noDataFoundForTheGivenId}
          sidebarStructure={dashboardDetailConfiguration?.configurationInfo?.sidebar_structure}
          className=""
          selectedData={currentUserRole}
      >
          {toastContainer?.show && <Toast {...toastContainer} />}

          {successFullyRequestedDocs && (
              <Toast
                  message="Request changes sent to user successfully!"
                  type="success"
                  autoClose={3000}
              />
          )}

          {successFullySentRequestForSupportingDocumentsTouser && (
              <Toast
                  message="Request for supporting documents sent to user successfully!"
                  type="success"
                  autoClose={3000}
              />
          )}
          {editUserDataRoutedSuccessFully && (
              <Toast
                  message="You are redirected to edit user data !"
                  type="success"
                  autoClose={3000}
              />
          )}
          {noDataFoundForTheGivenId && (
              <div className="text-center not-found-text noDataFoundDashboardDetail">
                  <img
                      style={{
                          objectFit: 'contain',
                          width: '60%',
                          height: '60%'
                      }}
                      src={NoDataFoundPic}
                      alt="No data found"
                  />
              </div>
          )}

          {/* <CustomeTab activeTab={activeTab} setActiveTab={setActiveTab} tab ={tab[0].tab_group}/> */}

          <Navbar className="bg-body-tertiary bg-theme-grey position-lg-sticky shadow-sm top-0 z-index-5">
              <Container fluid>
                  <Nav className="me-auto d-none d-lg-flex d-md-flex">
                    {formSkeleton?.[0]?.form_groups.map((item)=>(
                      item.fields.map(nav => (
                        <Nav.Link
                          className={`fs-14px fw-bold text-primary-theme nav-header position-relative me-4 ${
                              activeTab === `${nav.title}` ? 'active' : ''
                          }`}
                          // onClick={() => setActiveTab(nav.title)}
                          onClick={()=> handleActiveTab(nav.title)}
                      >
                          {nav.title}
                      </Nav.Link>
                      ))
                    ))}
                  </Nav>
                  <Dropdown className="d-lg-none d-md-none">
                      <Dropdown.Toggle
                          className="btn btn-theme"
                          id="dropdown-basic"
                      >
                          <span className="fs-15px mb-0 mt-1">
                              {activeTab}
                          </span>{() => setActiveTab('Applicants details')}
                          <span className="ps-1">
                              <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="14"
                                  height="14"
                                  fill="currentColor"
                                  class="bi bi-caret-down-fill"
                                  viewBox="0 0 16 16"
                              >
                                  <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                              </svg>
                          </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu className="border-0 rounded-0 shadow-sm">
                      {formSkeleton?.[0]?.form_groups.map((item)=>(
                      item.fields.map(nav => (
                        <Dropdown.Item
                        className={`fs-14px ${activeTab === nav.title ? 'd-none':''}`}
                        onClick={() => handleActiveTab(nav.title)}
                    >
                        {nav.title}
                    </Dropdown.Item>
                      ))
                    ))}
                      </Dropdown.Menu>
                  </Dropdown>
                  <Navbar.Toggle />
                  <Navbar.Collapse className="justify-content-end">
         {headerSkeleton?.list_items?.map(
                  (item, index) => {
                    if (IndirectEval(item?.show) && activeTab?.toLowerCase() !== "v-kyc") {

                      return (
                        <Fragment key={index}>
                          <DynamicForm
                            formFields={item}
                            formErr={formErr}
                            setFormErr={setFormErr}
                            clearFieldError={clearFieldError}
                            selectedData={selectedData}
                            setSelectedData={setSelectedData}
                          />
                        </Fragment>
                      );
                    }
                  }
                )}
                      <Dropdown
                          className="ms-3"
                          onToggle={() => setToggleIcon(!toggleIcon)}
                      >
                          <Dropdown.Toggle
                              variant="white"
                              className="p-0 border-0 cursor-pointer"
                              id="dropdown-basic"
                          >
                              <div className="d-flex align-items-center border-start border-1">
                                  {getProfilePicName(
                                      loggedInUserInfo?.profileInfo
                                          ?.first_name +
                                          ' ' +
                                          loggedInUserInfo?.profileInfo
                                              ?.last_name
                                  )}
                                  <span className="ms-1">
                                      <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="6.647"
                                          height="3.752"
                                          viewBox="0 0 6.647 3.752"
                                          className={`${
                                              toggleIcon ? 'rotate-180deg' : ''
                                          }`}
                                      >
                                          <path
                                              id="Path_54260"
                                              data-name="Path 54260"
                                              d="M3.323,0a.466.466,0,0,0-.329.135L.136,2.965a.458.458,0,0,0,0,.652.469.469,0,0,0,.658,0l2.529-2.5,2.529,2.5a.469.469,0,0,0,.658,0,.458.458,0,0,0,0-.652L3.653.135A.466.466,0,0,0,3.323,0Z"
                                              transform="translate(6.647 3.752) rotate(180)"
                                              fill="#757575"
                                          />
                                      </svg>
                                  </span>
                              </div>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                              className="end-0 border-0 rounded-0 shadow-sm min-w-100px"
                              style={{ left: 'unset' }}
                          >
                              <Dropdown.Item
                                  className="bg-active-grey fs-14px"
                                  onClick={() => logout()}
                              >
                                  Log out
                              </Dropdown.Item>
                          </Dropdown.Menu>
                      </Dropdown>
                  </Navbar.Collapse>
              </Container>
          </Navbar>

          <Container fluid className="mt-2">
              <Row className="p-0 bg-theme-grey h-100 flex-column justify-content-between">
                  <Col xs={12} md={12} lg={12} className="mb-2">
                      <Row className="p-0">
                          <Col
                              xs={12}
                              md={12}
                              lg={
                                  activeTab === 'Applicants details'
                                      ? `${value}`
                                      : 12
                              }
                              className={`px-lg-0 detailview-container-height mt-2 overflow-auto theme-scrollbar-hover bg-theme-grey position-relative
  `}
                          >
                            {/* {console.log("formSkeleton?.[0]?.form_groups",formSkeleton?.[0]?.form_groups)} */}
                              {formSkeleton?.[0]?.form_groups.map(
                                  (item, index) => (
                                      <Fragment key={item?.name}>
                                          <DynamicForm
                                              formFields={item}
                                              selectedData={selectedData}
                                              activeTab={activeTab}
                                              setActiveTab={setActiveTab}
                                              formErr={formErr}
                                              setFormErr={setFormErr}
                                              clearFieldError={clearFieldError}
                                          />
                                      </Fragment>
                                  )
                              )}
                          </Col>

                          {IndirectEval(formSkeleton?.[1]?.show) &&
                              activeTab === 'Applicants details' && (
                                  <div className="col-12 col-md-3 col-lg-3 .shadow-sm d-none d-lg-block bg-white">
                                      <ActivitySection
                                          form_groups={
                                              formSkeleton?.[1]?.form_groups
                                          }
                                      />
                                  </div>
                              )}
                      </Row>
                  </Col>

                  <Col
                      xs={12}
                      md={12}
                      lg={12}
                      className="position-sticky bottom-0 bg-white z-index-5"
                  >
                      <Row className="mx-2">
                          <Col xs={12} md={12} lg={12}>
                              <div className="bg-white w-100 d-flex align-items-center justify-content-end">
                                  <p className="fs-13px mb-0 me-1 mt-1">
                                      Powered by
                                  </p>
                                  <Image src={signdeskLogo} />
                              </div>
                          </Col>
                      </Row>
                  </Col>
              </Row>
          </Container>
          {activeTab == 2 && <p> Working on a KYC </p>}
          {sessiontimeout && <Autologout duration={defaultDuration} />}
      </DashBoard>
  );
};

export default DetailViewDashboard;
